import OrderTable from "components/orders/OrderTable";
import { InstallationSchema } from "types/installation";
import { isAdmin } from "utils/global";
import { ELIAS_ORDER_EMAIL_ADDRESS } from "utils/global/constants";

function OpenOrderH() {
  const filter = {
    acceptOrder: true,
    rejectOrder: false,
    failedOrder: false,
    closeOrder: false,
  };

  return (
    <div>
      <OrderTable
        pageSize={100}
        order="DESC"
        orderBy="createdAt"
        excludeEmail={ELIAS_ORDER_EMAIL_ADDRESS}
        rowClassName={(record: InstallationSchema) => {
          if (!isAdmin()) return "";
          if (record.closeOrder) return "";
          if (record.rejectOrder) return "installation-bg-gray";
          if (record.failedOrder) return "installation-bg-orange";
          if (!record.acceptOrder) return "installation-bg-green";
          return "installation-bg-yellow";
        }}
        statusFilter={filter}
      />
    </div>
  );
}

export default OpenOrderH;
